module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/src/lang",
  "moduleName": "H5-manhanttan-global-sofipo-sofipo",
  "version": 1035,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-manhanttan-global-sofipo-sofipo/src/lang/all.js",
  "noParse": false,
  "noOmega": true
}